export const GetImageFuture = (state = false, action) => {
    switch (action.type) {
        case 'IS_GET_IMAGE_FUTURE':
          return !state
        default:
          return state
    }
}